<template>
  <div>
    <unicom-linha
      :espacamento="false"
      style="min-height: 35px"
      class="carregando-tipo-vinculo"
    >
      <unicom-coluna sm="auto" alinhamento="center" class="mr-3">
        <unicom-icone style="color: #dee2e6" nome="pie-chart" :tamanho="25" />
      </unicom-coluna>
      <unicom-coluna sm="auto" alinhamento="center">
        <div
          style="color: #dee2e6; font-size: 21px"
          class="negrito fonte-primaria"
        >
          Tipo de vinculo
        </div>
      </unicom-coluna>
    </unicom-linha>
    <content-loader
      width="538"
      height="218"
      viewBox="0 0 538 218"
      primaryColor="#DEE2E6"
      secondaryColor="#f6f6f6"
      :speed="1"
    >
      <path
        id="Vetor importado"
        fill="none"
        stroke="black"
        stroke-width="1"
        d="M 29.00,125.00
                C 31.21,125.00 33.00,126.79 33.00,129.00
                    33.00,129.00 33.00,135.00 33.00,135.00
                    33.00,137.21 31.21,139.00 29.00,139.00
                    29.00,139.00 23.00,139.00 23.00,139.00
                    20.79,139.00 19.00,137.21 19.00,135.00
                    19.00,135.00 19.00,129.00 19.00,129.00
                    19.00,126.79 20.79,125.00 23.00,125.00
                    23.00,125.00 29.00,125.00 29.00,125.00 Z
                M 29.00,87.00
                C 31.21,87.00 33.00,88.79 33.00,91.00
                    33.00,91.00 33.00,97.00 33.00,97.00
                    33.00,99.21 31.21,101.00 29.00,101.00
                    29.00,101.00 23.00,101.00 23.00,101.00
                    20.79,101.00 19.00,99.21 19.00,97.00
                    19.00,97.00 19.00,91.00 19.00,91.00
                    19.00,88.79 20.79,87.00 23.00,87.00
                    23.00,87.00 29.00,87.00 29.00,87.00 Z
                M 29.00,49.00
                C 31.21,49.00 33.00,50.79 33.00,53.00
                    33.00,53.00 33.00,59.00 33.00,59.00
                    33.00,61.21 31.21,63.00 29.00,63.00
                    29.00,63.00 23.00,63.00 23.00,63.00
                    20.79,63.00 19.00,61.21 19.00,59.00
                    19.00,59.00 19.00,53.00 19.00,53.00
                    19.00,50.79 20.79,49.00 23.00,49.00
                    23.00,49.00 29.00,49.00 29.00,49.00 Z
                M 279.36,57.32
                C 293.79,39.26 315.98,27.68 340.89,27.65
                    340.89,27.65 340.94,63.13 340.94,63.13
                    327.24,63.15 315.03,69.52 307.10,79.45
                    307.10,79.45 279.36,57.32 279.36,57.32 Z
                M 306.76,177.53
                C 280.36,164.80 262.15,137.78 262.15,106.50
                    262.15,87.93 268.57,70.86 279.31,57.39
                    279.31,57.39 307.07,79.49 307.07,79.49
                    301.16,86.90 297.63,96.29 297.63,106.50
                    297.63,123.69 307.64,138.55 322.15,145.57
                    322.15,145.57 306.76,177.53 306.76,177.53 Z
                M 340.98,27.65
                C 340.99,27.65 340.99,27.65 341.00,27.65
                    384.55,27.65 419.85,62.95 419.85,106.50
                    419.85,150.05 384.55,185.35 341.00,185.35
                    328.76,185.35 317.17,182.56 306.83,177.58
                    306.83,177.58 322.21,145.58 322.21,145.58
                    327.88,148.33 334.26,149.87 341.00,149.87
                    364.95,149.87 384.37,130.45 384.37,106.50
                    384.37,82.55 364.95,63.13 341.00,63.13
                    341.00,63.13 340.99,63.13 340.99,63.13
                    340.99,63.13 340.98,27.65 340.98,27.65 Z"
      />
    </content-loader>
  </div>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
  components: {
    ContentLoader
  }
};
</script>

<style lang="scss" scoped>
.carregando-tipo-vinculo {
  position: relative;
  left: 3%;
}
</style>
